import { render, staticRenderFns } from "./TypeIcebreaker.vue?vue&type=template&id=e0848b5c&scoped=true"
import script from "./TypeIcebreaker.vue?vue&type=script&lang=js"
export * from "./TypeIcebreaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0848b5c",
  null
  
)

export default component.exports